import logger from "../../utils/logger";
import mixpanel from "mixpanel-browser";

const inProd = process.env.NODE_ENV === "production";

mixpanel.init(process.env.REACT_APP_MIXPANEL_TOKEN as string, {
  debug: !inProd,
  ignore_dnt: !inProd,
});

export const Mixpanel = {
  instance: mixpanel,
  identify(id: string) {
    if (inProd) {
      try {
        mixpanel.identify(id);
      } catch (error: any) {
        logger.error("mixpanel.identify error:", error);
      }
    }
  },
  track(name: string, props: any) {
    if (inProd) {
      try {
        mixpanel.track(name, props);
      } catch (error: any) {
        logger.error("mixpanel.track error:", error);
      }
    }
  },
};
